import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import UnclaimedTransactionList from "./unclaimedTransactionList";
import { fetchUnclaimedList } from "services/redux/maintenance/unclaimedTranx/action";
import UnclaimedTranxReducer from "../../../services/redux/maintenance/unclaimedTranx/reducer";
import { verifyInvoicesNumbers, editClientDetails } from "services/redux/maintenance/unclaimedTranx/action";
import {documentUploadUrlPublic} from "services/redux/fileUpload/action";

const mapStateToProps = (state) => ({
  unclaimedTransLists: state.UnclaimedTranxReducer.unclaimedTransLists,
  verifyInvoiceNumbersWithRecon: state.UnclaimedTranxReducer.verifyInvoiceNumbersWithRecon,
  editClientDetailsForTan: state.UnclaimedTranxReducer.editClientDetailsForTan,
  documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchUnclaimedList,
      verifyInvoicesNumbers,
      editClientDetails,
      documentUploadUrlPublic
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(UnclaimedTransactionList);
